import axios from "../../../../../axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import PreReadDeleteConfirmation from "../../Published/Three_Dot_Popup_Box/PreReadDeleteConfirmation";
import SchedulePrePopup from "../Schedule_Q_List/SchedulePrePopup";
import NoResponse from "../../../Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
// Here all css comes on PublishedAssessBox.css
const ScheduleAssessBoxPreRead = ({ filter }) => {
  const [preSDelete, setPreSDelete] = useState("");

  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [scheduledCard, setScheduledCard] = useState([]);
  const [noresponse, setNoresponse] = useState(false);

  useEffect(() => {
    const scheduledBox = async () => {
      let resposne = await axios.get(
        `/api/v1/homework/preRead/filterByTeacherId/${Teacher_Json}/scheduled?_page=1` +
        `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
        `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
        `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
        `&${filter?.date && `date=${filter?.date}`}` +
        `&${filter?.time && `time=${filter?.time}`}` +
        `&${filter?.subjectId?.length !== 0 && `subjectId=${filter?.subjectId}`
        }`
      );
      if (resposne?.data.data.length === 0) {
        setNoresponse(true);
      }
      setScheduledCard(resposne.data.data);
    };
    scheduledBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return scheduledCard && scheduledCard.length > 0 ? (
    <>
      {scheduledCard &&
        scheduledCard.length > 0 &&
        scheduledCard.map((schudleData) => (
          <div className=" d-flex  align-items-center published_Pre_box">
            <NavLink
              to={`/ScheduleQListPreRead`}
              className="link"
              state={{ schedulePre_id: schudleData?.id }}
            >
              <img
                className="publishedImgPre"
                src="/images/File-Pre-Read.png"
                alt=""
              />
            </NavLink>
            <div className=" ms-2 subpublished_pre_box">
              <div className=" d-flex  justify-content-between selected_pre_class_section">
                <NavLink
                  to="/ScheduleQListPreRead"
                  className="link"
                  state={{ schedulePre_id: schudleData?.id }}
                >
                  <div>
                    <span className="selected_pre_class">
                      Class {schudleData?.standard_id?.name} &nbsp;
                      {schudleData?.section_id?.name} -&nbsp;
                    </span>
                    <span className="selected_pre_class">
                      {schudleData?.subject_id?.name}
                    </span>
                  </div>
                </NavLink>

                <Popup
                  trigger={
                    <img
                      src="/images/menu-dots-vertical 1.svg"
                      className="published_pre_three_dot"
                      alt=""
                    />
                  }
                  content={
                    <div className="open_publish_pre_popupBox">
                      <SchedulePrePopup
                        schedulePre_id={schudleData?.id}
                        setPreSDelete={setPreSDelete}
                      />
                    </div>
                  }
                  on="click"
                  hideOnScroll
                  position="bottom right"
                />
              </div>
              <NavLink
                to="/ScheduleQListPreRead"
                className="link"
                state={{ schedulePre_id: schudleData?.id }}
              >
                <div className=" created_pre_name">{schudleData?.name}</div>

                <div className="col-12 p-0  d-flex  justify-content-between ">
                  <div className="col-6 p-0 ">
                    <span className="published_pre_subOn">Deadline : </span>
                    <span className="published_pre_submited_date">
                      {moment(schudleData?.deadline).calendar(null, {
                        sameDay: "[Today]",
                        nextDay: "[Tomorrow]",
                        nextWeek: "DD/MM/YYYY",
                        lastDay: "DD/MM/YYYY",
                        lastWeek: "DD/MM/YYYY",
                        sameElse: "DD/MM/YYYY",
                      })}
                    </span>
                  </div>
                  <div className="col-5 p-0 d-flex align-items-end flex-column ">
                    <span className="published_pre_subOn"> Scheduled on</span>

                    <span className="published_pre_submited_date">
                      {moment(schudleData?.schedule_date).calendar(null, {
                        sameDay: "[Today]",
                        nextDay: "[Tomorrow]",
                        nextWeek: "DD/MM/YYYY",
                        lastDay: "DD/MM/YYYY",
                        lastWeek: "DD/MM/YYYY",
                        sameElse: "DD/MM/YYYY",
                      })}
                    </span>
                  </div>
                </div>

                {/* <div className="">
                  <span className="published_pre_subOn">
                    Scheduled on :&nbsp;
                    {moment(schudleData?.schedule_date).calendar(null, {
                      sameDay: "[Today]",
                      nextDay: "[Tomorrow]",
                      nextWeek: "DD/MM/YYYY",
                      lastDay: "DD/MM/YYYY",
                      lastWeek: "DD/MM/YYYY",
                      sameElse: "DD/MM/YYYY",
                    })}
                    &nbsp; |
                  </span>
                  <span className="published_pre_submited_date">
                    &nbsp;
                    {moment(schudleData?.schedule_time).format("h:mm A")}
                  </span>
                </div> */}
                {/* </div> */}
              </NavLink>
            </div>
            {preSDelete && (
              <PreReadDeleteConfirmation
                setPreSDelete={setPreSDelete}
                scheduleData={schudleData}
                scheduleData_id={schudleData?.id}
              />
            )}
          </div>
        ))}
    </>
  ) : (
    <>
      <img
        className="publishAccessLoader"
        src="/gift/black loader.gif"
        alt=""
      />
      {noresponse && <NoResponse setNoresponse={setNoresponse} />}
    </>
  );
};

export default ScheduleAssessBoxPreRead;
